// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"V1-z","displaySixCardTiles":"W1-z"};